/**
 * AuthPort — porta de autenticação (mesmo desenho do PAN).
 *
 * A aplicação declara a *porta* que precisa e o composition root (`main.tsx`)
 * injeta uma implementação: Keycloak no modo `rest`, estática no `demo`. Nada
 * no restante do código conhece Keycloak.
 */

export interface AuthPort {
  /** Devolve um access token válido, renovando quando necessário. */
  getToken(): Promise<string>;
  /** Identificação do usuário para o chip da topbar. Nulo = anônimo/demo. */
  getIdentity(): Promise<{ nome: string; detalhe: string } | null>;
  /** Capabilities do usuário (roles do client `compilacoes-api-confidential` + `sysadmin` de realm). */
  getRoles(): Promise<string[]>;
  /** Encerra a sessão. Não aplicável em demo (no-op). */
  logout(): void;
}

/** Porta usada no modo demo e em desenvolvimento sem provedor configurado. */
export function createStaticAuthPort(
  token: string,
  identity?: { nome: string; detalhe: string },
  roles: string[] = [],
): AuthPort {
  return {
    getToken: async () => token,
    getIdentity: async () => identity ?? null,
    getRoles: async () => roles,
    logout: () => {},
  };
}

let current: AuthPort = createStaticAuthPort('');

export function setAuthPort(port: AuthPort): void {
  current = port;
}

export function getAuthPort(): AuthPort {
  return current;
}
